export type OnGoChoiceDisplayState =
  | 'question-selected'
  | 'question-unselected'
  | 'result-correct'
  | 'result-incorrect'
  | 'result-muted';

export const resolveOnGoChoiceDisplayState = (
  isResultPhase: boolean,
  isSelected: boolean,
  isCorrectOption: boolean,
  isAttemptCorrect: boolean | null,
): OnGoChoiceDisplayState => {
  if (!isResultPhase) {
    if (isSelected) {
      return 'question-selected';
    }
    return 'question-unselected';
  }

  if (isCorrectOption) {
    return 'result-correct';
  }

  if (isSelected && isAttemptCorrect === false) {
    return 'result-incorrect';
  }

  return 'result-muted';
};
